module.exports = __webpack_public_path__ + "img/branches.4a6cf575.svg";